import moment from "moment"

export const dateFormater = (date) => {
    return moment(new Date(date)).format("DD/MM/YYYY");
}

export const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  apheresis_date: {
    label: "Apheresis Date",
  },
};

export const labelTypeList = [
    {label:'In-Bound',value:'1'},
    {label:'Cart-T',value:'2'},
    {label:'COA',value:'3'},
    {label:'Out-Bound',value:'4'},
    {label:'Label Print',value:'5'},
    {label:'Manufacturing Print',value:'6'},
    {label:'Batch Print',value:'7'},
    {label:'Cryo Print',value:'8'}
]

export const filterConfigRecived = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
};

export const filterConfigStatus = {
  status: {
    label: "status",
    enum: {
      0: "Pending",
      1: "Submitted",
      2: "Published",
      3: "Draft",
    },
  },
    versions: {
    label: "versions",
   
  },
};
